import { getSnowflakeJoinsMetadata } from './joins-with-meta';
export const getSnowflakeJoins = () => {
  return getSnowflakeJoinsMetadata().then(snowflakeJoinsMetadata => snowflakeJoinsMetadata.map(mapOfObjectIdToSnowflakeJoinMetadata => mapOfObjectIdToSnowflakeJoinMetadata.keySeq().toList()).toMap());
};